import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
  IconButton,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function AperçuModal({ open, handleClose, data }) {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6" sx={{ fontWeight: 400, textTransform: "uppercase" }}>
          Aperçu du Rapport
        </Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table>
            <TableHead>
              <TableRow>
                {[
                  "Site",
                  "Matricule",
                  "Nom",
                  "Prénom",
                  "Adresse",
                  "GPS (latitude, longitude)",
                  "Tel",
                  "Email",
                  "Date",
                ].map((header) => (
                  <TableCell key={header} sx={{ fontWeight: "bold", borderBottom: "2px solid #ddd" }}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data && data.length > 0 ? (
                data.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ borderBottom: "1px solid #ddd" }}>{row.site}</TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd" }}>{row.matricule}</TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd" }}>{row.nom}</TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd" }}>{row.prenom}</TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd" }}>{row.adresse}</TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd" }}>{row.gps}</TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd" }}>{row.tel}</TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd" }}>{row.email}</TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #ddd" }}>{row.date}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ borderBottom: "1px solid #ddd" }}>
                    Aucun résultat n'a été trouvé
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <Divider sx={{ mb: 1 }} />
      <DialogActions sx={{ justifyContent: "flex-end" }}>
        <Button
          onClick={handleClose}
          sx={{ backgroundColor: "red", color: "#fff", "&:hover": { backgroundColor: "red" }, textTransform: "none" }}
        >
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
}
